import apiClient from "./base.service";

export default {
    async index(event_id) {
        return await apiClient.get(`/event/${event_id}/task`);
    },
    async get(event_id, team_id, id) {
        return await apiClient.get(`/event/${event_id}/team/${team_id}/task/${id}`);
    },
    async update(event_id, team_id, id, data) {
        return await apiClient.put(`/event/${event_id}/team/${team_id}/task/${id}`, data);
    },
    async create(event_id, team_id, data) {
        return await apiClient.post(`/event/${event_id}/team/${team_id}/task`, data);
    },
    async remove(event_id, team_id, id) {
        return await apiClient.delete(`/event/${event_id}/team/${team_id}/task/${id}`);
    }
}